import script from "./DashboardPolicyUpdates.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardPolicyUpdates.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__